import { useState } from 'react';

import { useParams } from 'react-router-dom';

import { useSubscribeToTopic, WebsocketTopicIds } from '@app/helpers';
import { PathParams } from '@app/routes/types';

const ON_ACTIVE_OWNERS_MESSAGE = 'on-active-owners-message';
const getActiveOwnersTopic = (slug: string) => `CurrentWalletCount,${slug}`;

export const useGetActiveOwners = (props?: { slug: string }) => {
    const { [PathParams.CollectionSlug]: collectionSlugParam } = useParams();

    const slug = props?.slug || collectionSlugParam || '';
    const [activeOwners, setActiveOwners] = useState(0);

    const onMessage = (msj) => {
        const activeOwners = JSON.parse(msj.data);
        setActiveOwners(activeOwners);
    };

    useSubscribeToTopic({
        topic: getActiveOwnersTopic(slug),
        id: WebsocketTopicIds.ActiveOwners,
        messageKey: ON_ACTIVE_OWNERS_MESSAGE,
        onmessage: onMessage,
    });

    return activeOwners || 0;
};
